import { createContext, Dispatch, PropsWithChildren, SetStateAction, useContext, useState } from 'react';
import { noop } from 'lodash-es';
import { SpacesQuery } from '@zep/types';
type SearchFilterContextType = {
  filterType: SpacesQuery.MY | SpacesQuery.RECENT;
  setFilterType: Dispatch<SetStateAction<SpacesQuery.MY | SpacesQuery.RECENT>>;
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  isShowSearchInput: boolean;
  setIsShowSearchInput: Dispatch<SetStateAction<boolean>>;
};
const SearchFilterContext = createContext<SearchFilterContextType>({
  filterType: SpacesQuery.RECENT,
  setFilterType: noop,
  searchQuery: '',
  setSearchQuery: noop,
  isShowSearchInput: true,
  setIsShowSearchInput: noop
});
export const SearchFilterContextProvider = ({
  children
}: PropsWithChildren) => {
  const [filterType, setFilterType] = useState<SpacesQuery.MY | SpacesQuery.RECENT>(SpacesQuery.RECENT);
  const [searchQuery, setSearchQuery] = useState('');
  const [isShowSearchInput, setIsShowSearchInput] = useState(true);
  return <SearchFilterContext.Provider value={{
    filterType,
    searchQuery,
    setFilterType,
    setSearchQuery,
    isShowSearchInput,
    setIsShowSearchInput
  }} data-sentry-element="unknown" data-sentry-component="SearchFilterContextProvider" data-sentry-source-file="SearchFilterContextProvider.tsx">
      {children}
    </SearchFilterContext.Provider>;
};
export const useSearchFilterContext = () => {
  const context = useContext(SearchFilterContext);
  if (!context) {
    throw new Error('useSearchFilter must be used within a SearchFilterProvider');
  }
  return context;
};